import React from 'react';
import Skeleton from 'react-loading-skeleton';

const SkeletonLayout = () => {
  return (
    <div className=''>
      <div className='row'>
        <div className='col-12'>
          <Skeleton className='h-10' />
        </div>
      </div>
      <div className='row justify-content-center mt-4'>
        <div className='col-5'>
          <Skeleton height={500} />
        </div>
      </div>
      <div className='row mt-4'>
        <div className='col-12'>
          <Skeleton height={5} className='mb-1' />
          <Skeleton height={10} className='py-3 mb-2' />
          <Skeleton height={60} className='py-3' />
        </div>
      </div>
    </div>
  );
};

export default SkeletonLayout;
